import {
  Component,
  Input,
  ElementRef,
  OnInit,
  OnChanges,
  DoCheck,
  AfterViewInit,
  OnDestroy,
  KeyValueDiffers,
  ViewChild,
  NgZone,
  Output,
  EventEmitter
} from '@angular/core';

import { FroalaChartsService } from './froalacharts.service';
import { FroalaChartsConstructor } from './froalacharts.constructor';
import FroalaChartsEvent from '../interfaces/FroalaChartsEvent';
import FroalaChartInstance from '../interfaces/FroalaChartInstance';
import EventsList from '../events/events';

class FroalaChartsComponent
  implements OnInit, OnChanges, DoCheck, AfterViewInit, OnDestroy {
  chartObj: any;

   placeholder: string;
   dataSource: any;
   type: string;
   id: string;
   width: string;
   height: string;
   renderAt: string;
   dataFormat: string;
   events: string;
   link: string;
   showDataLoadingMessage: boolean;
   showChartLoadingMessage: boolean;
   baseChartMessageFont: string;
   baseChartMessageFontSize: string;
   baseChartMessageColor: string;
   dataLoadStartMessage: string;
   dataLoadErrorMessage: string;
   dataInvalidMessage: string;
   dataEmptyMessage: string;
   typeNotSupportedMessage: string;
   loadMessage: string;
   renderErrorMessage: string;
   containerBackgroundColor: string;
   containerBackgroundOpacity: string;
   containerClassName: string;
   baseChartMessageImageHAlign: string;
   baseChartMessageImageVAlign: string;
   baseChartMessageImageAlpha: number;
   baseChartMessageImageScale: number;
   typeNotSupportedMessageImageHAlign: string;
   typeNotSupportedMessageImageVAlign: string;
   typeNotSupportedMessageImageAlpha: number;
   typeNotSupportedMessageImageScale: number;
   dataLoadErrorMessageImageHAlign: string;
   dataLoadErrorMessageImageVAlign: string;
   dataLoadErrorMessageImageAlpha: number;
   dataLoadErrorMessageImageScale: number;
   dataLoadStartMessageImageHAlign: string;
   dataLoadStartMessageImageVAlign: string;
   dataLoadStartMessageImageAlpha: number;
   dataLoadStartMessageImageScale: number;
   dataInvalidMessageImageHAlign: string;
   dataInvalidMessageImageVAlign: string;
   dataInvalidMessageImageAlpha: number;
   dataInvalidMessageImageScale: number;
   dataEmptyMessageImageHAlign: string;
   dataEmptyMessageImageVAlign: string;
   dataEmptyMessageImageAlpha: number;
   dataEmptyMessageImageScale: number;
   renderErrorMessageImageHAlign: string;
   renderErrorMessageImageVAlign: string;
   renderErrorMessageImageAlpha: number;
   renderErrorMessageImageScale: number;
   loadMessageImageHAlign: string;
   loadMessageImageVAlign: string;
   loadMessageImageAlpha: number;
   loadMessageImageScale: number;
   chartConfig: string;

  /**
   * All Events List
   */

  private eventList: Array<string> = EventsList;

  /**
   * All events emitter
   */
   beforeLinkedItemOpen = new EventEmitter<FroalaChartsEvent>();
   linkedItemOpened = new EventEmitter<FroalaChartsEvent>();
   beforeLinkedItemClose = new EventEmitter<FroalaChartsEvent>();
   linkedItemClosed = new EventEmitter<FroalaChartsEvent>();
   printReadyStateChange = new EventEmitter<FroalaChartsEvent>();
   dataLoadRequestCompleted = new EventEmitter<FroalaChartsEvent>();
   dataLoadError = new EventEmitter<FroalaChartsEvent>();
   dataLoadCancelled = new EventEmitter<FroalaChartsEvent>();
   dataLoadRequestCancelled = new EventEmitter<FroalaChartsEvent>();
   dataUpdated = new EventEmitter<FroalaChartsEvent>();
   dataUpdateCancelled = new EventEmitter<FroalaChartsEvent>();
   dataLoadRequested = new EventEmitter<FroalaChartsEvent>();
   beforeDataUpdate = new EventEmitter<FroalaChartsEvent>();
   realTimeUpdateComplete = new EventEmitter<FroalaChartsEvent>();
   chartCleared = new EventEmitter<FroalaChartsEvent>();
   slicingEnd = new EventEmitter<FroalaChartsEvent>();
   slicingStart = new EventEmitter<FroalaChartsEvent>();
   entityRollOut = new EventEmitter<FroalaChartsEvent>();
   entityRollOver = new EventEmitter<FroalaChartsEvent>();
   entityClick = new EventEmitter<FroalaChartsEvent>();
   connectorRollOver = new EventEmitter<FroalaChartsEvent>();
   connectorRollOut = new EventEmitter<FroalaChartsEvent>();
   connectorClick = new EventEmitter<FroalaChartsEvent>();
   markerRollOver = new EventEmitter<FroalaChartsEvent>();
   markerRollOut = new EventEmitter<FroalaChartsEvent>();
   markerClick = new EventEmitter<FroalaChartsEvent>();
   pageNavigated = new EventEmitter<FroalaChartsEvent>();
   rotationEnd = new EventEmitter<FroalaChartsEvent>();
   rotationStart = new EventEmitter<FroalaChartsEvent>();
   centerLabelRollover = new EventEmitter<FroalaChartsEvent>();
   centerLabelRollout = new EventEmitter<FroalaChartsEvent>();
   centerLabelClick = new EventEmitter<FroalaChartsEvent>();
   centerLabelChanged = new EventEmitter<FroalaChartsEvent>();
   chartClick = new EventEmitter<FroalaChartsEvent>();
   chartMouseMove = new EventEmitter<FroalaChartsEvent>();
   chartRollOver = new EventEmitter<FroalaChartsEvent>();
   chartRollOut = new EventEmitter<FroalaChartsEvent>();
   backgroundLoaded = new EventEmitter<FroalaChartsEvent>();
   backgroundLoadError = new EventEmitter<FroalaChartsEvent>();
   legendItemClicked = new EventEmitter<FroalaChartsEvent>();
   legendItemRollover = new EventEmitter<FroalaChartsEvent>();
   legendItemRollout = new EventEmitter<FroalaChartsEvent>();
   logoRollover = new EventEmitter<FroalaChartsEvent>();
   logoRollout = new EventEmitter<FroalaChartsEvent>();
   logoClick = new EventEmitter<FroalaChartsEvent>();
   logoLoaded = new EventEmitter<FroalaChartsEvent>();
   logoLoadError = new EventEmitter<FroalaChartsEvent>();
   beforeExport = new EventEmitter<FroalaChartsEvent>();
   exported = new EventEmitter<FroalaChartsEvent>();
   exportCancelled = new EventEmitter<FroalaChartsEvent>();
   beforePrint = new EventEmitter<FroalaChartsEvent>();
   printComplete = new EventEmitter<FroalaChartsEvent>();
   printCancelled = new EventEmitter<FroalaChartsEvent>();
   dataLabelClick = new EventEmitter<FroalaChartsEvent>();
   dataLabelRollOver = new EventEmitter<FroalaChartsEvent>();
   dataLabelRollOut = new EventEmitter<FroalaChartsEvent>();
   scrollStart = new EventEmitter<FroalaChartsEvent>();
   scrollEnd = new EventEmitter<FroalaChartsEvent>();
   onScroll = new EventEmitter<FroalaChartsEvent>();
   zoomReset = new EventEmitter<FroalaChartsEvent>();
   zoomedOut = new EventEmitter<FroalaChartsEvent>();
   zoomedIn = new EventEmitter<FroalaChartsEvent>();
   zoomed = new EventEmitter<FroalaChartsEvent>();
   zoomModeChanged = new EventEmitter<FroalaChartsEvent>();
   pinned = new EventEmitter<FroalaChartsEvent>();
   dataRestored = new EventEmitter<FroalaChartsEvent>();
   beforeDataSubmit = new EventEmitter<FroalaChartsEvent>();
   dataSubmitError = new EventEmitter<FroalaChartsEvent>();
   dataSubmitted = new EventEmitter<FroalaChartsEvent>();
   dataSubmitCancelled = new EventEmitter<FroalaChartsEvent>();
   chartUpdated = new EventEmitter<FroalaChartsEvent>();
   nodeAdded = new EventEmitter<FroalaChartsEvent>();
   nodeUpdated = new EventEmitter<FroalaChartsEvent>();
   nodeDeleted = new EventEmitter<FroalaChartsEvent>();
   connectorAdded = new EventEmitter<FroalaChartsEvent>();
   connectorUpdated = new EventEmitter<FroalaChartsEvent>();
   connectorDeleted = new EventEmitter<FroalaChartsEvent>();
   labelAdded = new EventEmitter<FroalaChartsEvent>();
   labelDeleted = new EventEmitter<FroalaChartsEvent>();
   selectionRemoved = new EventEmitter<FroalaChartsEvent>();
   selectionStart = new EventEmitter<FroalaChartsEvent>();
   selectionEnd = new EventEmitter<FroalaChartsEvent>();
   labelClick = new EventEmitter<FroalaChartsEvent>();
   labelRollOver = new EventEmitter<FroalaChartsEvent>();
   labelRollOut = new EventEmitter<FroalaChartsEvent>();
   labelDragStart = new EventEmitter<FroalaChartsEvent>();
   labelDragEnd = new EventEmitter<FroalaChartsEvent>();
   dataplotDragStart = new EventEmitter<FroalaChartsEvent>();
   dataplotDragEnd = new EventEmitter<FroalaChartsEvent>();
   processClick = new EventEmitter<FroalaChartsEvent>();
   processRollOver = new EventEmitter<FroalaChartsEvent>();
   processRollOut = new EventEmitter<FroalaChartsEvent>();
   categoryClick = new EventEmitter<FroalaChartsEvent>();
   categoryRollOver = new EventEmitter<FroalaChartsEvent>();
   categoryRollOut = new EventEmitter<FroalaChartsEvent>();
   milestoneClick = new EventEmitter<FroalaChartsEvent>();
   milestoneRollOver = new EventEmitter<FroalaChartsEvent>();
   milestoneRollOut = new EventEmitter<FroalaChartsEvent>();
   chartTypeChanged = new EventEmitter<FroalaChartsEvent>();
   overlayButtonClick = new EventEmitter<FroalaChartsEvent>();
   loaded = new EventEmitter<FroalaChartsEvent>();
   rendered = new EventEmitter<FroalaChartsEvent>();
   drawComplete = new EventEmitter<FroalaChartsEvent>();
   renderComplete = new EventEmitter<FroalaChartsEvent>();
   dataInvalid = new EventEmitter<FroalaChartsEvent>();
   dataXMLInvalid = new EventEmitter<FroalaChartsEvent>();
   dataLoaded = new EventEmitter<FroalaChartsEvent>();
   noDataToDisplay = new EventEmitter<FroalaChartsEvent>();
   legendPointerDragStart = new EventEmitter<FroalaChartsEvent>();
   legendPointerDragStop = new EventEmitter<FroalaChartsEvent>();
   legendRangeUpdated = new EventEmitter<FroalaChartsEvent>();
   alertComplete = new EventEmitter<FroalaChartsEvent>();
   realTimeUpdateError = new EventEmitter<FroalaChartsEvent>();
   dataplotRollOver = new EventEmitter<FroalaChartsEvent>();
   dataplotRollOut = new EventEmitter<FroalaChartsEvent>();
   dataplotClick = new EventEmitter<FroalaChartsEvent>();
   linkClicked = new EventEmitter<FroalaChartsEvent>();
   beforeRender = new EventEmitter<FroalaChartsEvent>();
   renderCancelled = new EventEmitter<FroalaChartsEvent>();
   beforeResize = new EventEmitter<FroalaChartsEvent>();
   resized = new EventEmitter<FroalaChartsEvent>();
   resizeCancelled = new EventEmitter<FroalaChartsEvent>();
   beforeDispose = new EventEmitter<FroalaChartsEvent>();
   disposed = new EventEmitter<FroalaChartsEvent>();
   disposeCancelled = new EventEmitter<FroalaChartsEvent>();
   linkedChartInvoked = new EventEmitter<FroalaChartsEvent>();
   beforeDrillDown = new EventEmitter<FroalaChartsEvent>();
   drillDown = new EventEmitter<FroalaChartsEvent>();
   beforeDrillUp = new EventEmitter<FroalaChartsEvent>();
   drillUp = new EventEmitter<FroalaChartsEvent>();
   drillDownCancelled = new EventEmitter<FroalaChartsEvent>();
   drillUpCancelled = new EventEmitter<FroalaChartsEvent>();
   initialized = new EventEmitter<FroalaChartInstance>();

  containerId: string;
  private configObj: any;
  private oldDataSource: any = this.dataSource;
  private oldDataTable: any;
  private constructerParams = {
    type: true,
    id: true,
    width: true,
    height: true,
    renderAt: true,
    dataFormat: true,
    dataSource: true,
    events: true,
    link: true,
    showDataLoadingMessage: true,
    showChartLoadingMessage: true,
    baseChartMessageFont: true,
    baseChartMessageFontSize: true,
    baseChartMessageColor: true,
    dataLoadStartMessage: true,
    dataLoadErrorMessage: true,
    dataInvalidMessage: true,
    dataEmptyMessage: true,
    typeNotSupportedMessage: true,
    loadMessage: true,
    renderErrorMessage: true,
    containerBackgroundColor: true,
    containerBackgroundOpacity: true,
    containerClassName: true,
    baseChartMessageImageHAlign: true,
    baseChartMessageImageVAlign: true,
    baseChartMessageImageAlpha: true,
    baseChartMessageImageScale: true,
    typeNotSupportedMessageImageHAlign: true,
    typeNotSupportedMessageImageVAlign: true,
    typeNotSupportedMessageImageAlpha: true,
    typeNotSupportedMessageImageScale: true,
    dataLoadErrorMessageImageHAlign: true,
    dataLoadErrorMessageImageVAlign: true,
    dataLoadErrorMessageImageAlpha: true,
    dataLoadErrorMessageImageScale: true,
    dataLoadStartMessageImageHAlign: true,
    dataLoadStartMessageImageVAlign: true,
    dataLoadStartMessageImageAlpha: true,
    dataLoadStartMessageImageScale: true,
    dataInvalidMessageImageHAlign: true,
    dataInvalidMessageImageVAlign: true,
    dataInvalidMessageImageAlpha: true,
    dataInvalidMessageImageScale: true,
    dataEmptyMessageImageHAlign: true,
    dataEmptyMessageImageVAlign: true,
    dataEmptyMessageImageAlpha: true,
    dataEmptyMessageImageScale: true,
    renderErrorMessageImageHAlign: true,
    renderErrorMessageImageVAlign: true,
    renderErrorMessageImageAlpha: true,
    renderErrorMessageImageScale: true,
    loadMessageImageHAlign: true,
    loadMessageImageVAlign: true,
    loadMessageImageAlpha: true,
    loadMessageImageScale: true,
    chartConfig: true
  };
  element: ElementRef;
  froalachartsService: FroalaChartsService;

  constructor(
    element: ElementRef,
    froalachartsService: FroalaChartsService,
    private differs: KeyValueDiffers,
    private zone: NgZone
  ) {
    this.element = element;
    this.froalachartsService = froalachartsService;
    this.containerId = froalachartsService.getNextItemCount();
  }

  // @ViewChild('samplediv') chartContainer: ElementRef;

  checkIfDataTableExists(dataSource) {
    if (dataSource && dataSource.data && dataSource.data._dataStore) {
      return true;
    }
    return false;
  }

  cloneDataSource(obj) {
    let type = typeof obj;
    if (
      type === 'string' ||
      type === 'number' ||
      type === 'function' ||
      type === 'boolean'
    ) {
      return obj;
    }
    if (obj === null || obj === undefined) {
      return obj;
    }
    if (Array.isArray(obj)) {
      let arr: any[] = [];
      for (let i = 0; i < obj.length; i++) {
        arr.push(this.cloneDataSource(obj[i]));
      }
      return arr;
    }
    if (typeof obj === 'object') {
      let clonedObj = {};
      for (let prop in obj) {
        // Edge case handling for DataTable
        if (prop === 'data') {
          if (obj[prop]._dataStore) {
            clonedObj[prop] = `-`;
          } else {
            clonedObj[prop] = this.cloneDataSource(obj[prop]);
          }
          continue;
        }
        clonedObj[prop] = this.cloneDataSource(obj[prop]);
      }
      return clonedObj;
    }
  }

  ngOnInit() {
    if (this.checkIfDataTableExists(this.dataSource)) {
      this.oldDataSource = JSON.stringify(
        this.cloneDataSource(this.dataSource)
      );
    } else {
      this.oldDataSource = JSON.stringify(this.dataSource);
    }
    this.placeholder = this.placeholder || 'FroalaCharts will render here';
  }

  ngOnChanges(changes: any) {
    for (const i of Object.keys(changes)) {
      const key = i.charAt(0).toUpperCase() + i.slice(1),
        THIS = this,
        fnName = `update${key}`;
      if (THIS[fnName]) {
        THIS[fnName]();
      }
    }
  }

  ngDoCheck() {
    let data;
    if (this.checkIfDataTableExists(this.dataSource)) {
      data = JSON.stringify(this.cloneDataSource(this.dataSource));
    } else {
      data = JSON.stringify(this.dataSource);
    }
    if (
      this.oldDataSource !== data ||
      this.oldDataTable !== this.dataSource.data
    ) {
      this.oldDataTable = this.dataSource && this.dataSource.data;
      this.oldDataSource = data;
      this.updateChartData();
    }
  }

  updateChartData() {
    const dataFormat =
        this.configObj && this.configObj.dataFormat
          ? this.configObj.dataFormat
          : 'json',
      data = this.dataSource;

    if (this.chartObj) {
      this.chartObj.setChartData(data, dataFormat);
    }
  }

  updateWidth() {
    if (this.chartObj) {
      this.chartObj.resizeTo({
        w: this.width
      });
    }
  }

  updateHeight() {
    if (this.chartObj) {
      this.chartObj.resizeTo({
        h: this.height
      });
    }
  }

  updateType() {
    if (this.chartObj) {
      this.chartObj.chartType(this.type);
    }
  }

  generateEventsCallback(eventList: Array<string>) {
    let events = {};
    eventList.forEach(eventName => {
      events[eventName] = (eventObj: any, dataObj: any) => {
        let fEventObj: FroalaChartsEvent = { eventObj: {}, dataObj: {} };
        if (eventObj) fEventObj.eventObj = eventObj;
        if (dataObj) fEventObj.dataObj = dataObj;
        this[eventName].emit(fEventObj);
      };
    });
    return events;
  }

  ngAfterViewInit() {
    const _this = this,
      params = _this.constructerParams,
      configObj = _this.configObj || (_this.configObj = {});

    let _chartConfig: any = _this.chartConfig || {};

    if (typeof _chartConfig === 'string') {
      _chartConfig = JSON.parse(_chartConfig);
    }

    for (const i of Object.keys(params)) {
      const value = _this[i] || _chartConfig[i];
      if (value) {
        configObj[i] = value;
      }
    }

    if (configObj['type']) {
      let events = _this.generateEventsCallback(_this.eventList);
      if (!configObj['events']) {
        configObj['events'] = events;
      } else {
        configObj['events'] = Object.assign(events, configObj['events']);
      }

      // configObj['renderAt'] = 'container-' + _this.chartObj.id;
      // _this.containerId = _this.chartObj.id;

      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          _this.chartObj = FroalaChartsConstructor(
            _this.froalachartsService,
            configObj
          );
          this.initialized.emit({ chart: _this.chartObj });
          _this.chartObj.render(
            _this.element.nativeElement.querySelector('div')
          );
        }, 1);
      });
    }
  }

  ngOnDestroy() {
    this.chartObj && this.chartObj.dispose();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'froalacharts',
  template: `
    <div attr.id="container-{{ containerId }}" style="width:100%;height:100%">
      {{ placeholder }}
    </div>
  `,
  providers: [FroalaChartsService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: FroalaChartsService, },
{type: KeyValueDiffers, },
{type: NgZone, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'placeholder': [{ type: Input },],
'dataSource': [{ type: Input },],
'type': [{ type: Input },],
'id': [{ type: Input },],
'width': [{ type: Input },],
'height': [{ type: Input },],
'renderAt': [{ type: Input },],
'dataFormat': [{ type: Input },],
'events': [{ type: Input },],
'link': [{ type: Input },],
'showDataLoadingMessage': [{ type: Input },],
'showChartLoadingMessage': [{ type: Input },],
'baseChartMessageFont': [{ type: Input },],
'baseChartMessageFontSize': [{ type: Input },],
'baseChartMessageColor': [{ type: Input },],
'dataLoadStartMessage': [{ type: Input },],
'dataLoadErrorMessage': [{ type: Input },],
'dataInvalidMessage': [{ type: Input },],
'dataEmptyMessage': [{ type: Input },],
'typeNotSupportedMessage': [{ type: Input },],
'loadMessage': [{ type: Input },],
'renderErrorMessage': [{ type: Input },],
'containerBackgroundColor': [{ type: Input },],
'containerBackgroundOpacity': [{ type: Input },],
'containerClassName': [{ type: Input },],
'baseChartMessageImageHAlign': [{ type: Input },],
'baseChartMessageImageVAlign': [{ type: Input },],
'baseChartMessageImageAlpha': [{ type: Input },],
'baseChartMessageImageScale': [{ type: Input },],
'typeNotSupportedMessageImageHAlign': [{ type: Input },],
'typeNotSupportedMessageImageVAlign': [{ type: Input },],
'typeNotSupportedMessageImageAlpha': [{ type: Input },],
'typeNotSupportedMessageImageScale': [{ type: Input },],
'dataLoadErrorMessageImageHAlign': [{ type: Input },],
'dataLoadErrorMessageImageVAlign': [{ type: Input },],
'dataLoadErrorMessageImageAlpha': [{ type: Input },],
'dataLoadErrorMessageImageScale': [{ type: Input },],
'dataLoadStartMessageImageHAlign': [{ type: Input },],
'dataLoadStartMessageImageVAlign': [{ type: Input },],
'dataLoadStartMessageImageAlpha': [{ type: Input },],
'dataLoadStartMessageImageScale': [{ type: Input },],
'dataInvalidMessageImageHAlign': [{ type: Input },],
'dataInvalidMessageImageVAlign': [{ type: Input },],
'dataInvalidMessageImageAlpha': [{ type: Input },],
'dataInvalidMessageImageScale': [{ type: Input },],
'dataEmptyMessageImageHAlign': [{ type: Input },],
'dataEmptyMessageImageVAlign': [{ type: Input },],
'dataEmptyMessageImageAlpha': [{ type: Input },],
'dataEmptyMessageImageScale': [{ type: Input },],
'renderErrorMessageImageHAlign': [{ type: Input },],
'renderErrorMessageImageVAlign': [{ type: Input },],
'renderErrorMessageImageAlpha': [{ type: Input },],
'renderErrorMessageImageScale': [{ type: Input },],
'loadMessageImageHAlign': [{ type: Input },],
'loadMessageImageVAlign': [{ type: Input },],
'loadMessageImageAlpha': [{ type: Input },],
'loadMessageImageScale': [{ type: Input },],
'chartConfig': [{ type: Input },],
'beforeLinkedItemOpen': [{ type: Output },],
'linkedItemOpened': [{ type: Output },],
'beforeLinkedItemClose': [{ type: Output },],
'linkedItemClosed': [{ type: Output },],
'printReadyStateChange': [{ type: Output },],
'dataLoadRequestCompleted': [{ type: Output },],
'dataLoadError': [{ type: Output },],
'dataLoadCancelled': [{ type: Output },],
'dataLoadRequestCancelled': [{ type: Output },],
'dataUpdated': [{ type: Output },],
'dataUpdateCancelled': [{ type: Output },],
'dataLoadRequested': [{ type: Output },],
'beforeDataUpdate': [{ type: Output },],
'realTimeUpdateComplete': [{ type: Output },],
'chartCleared': [{ type: Output },],
'slicingEnd': [{ type: Output },],
'slicingStart': [{ type: Output },],
'entityRollOut': [{ type: Output },],
'entityRollOver': [{ type: Output },],
'entityClick': [{ type: Output },],
'connectorRollOver': [{ type: Output },],
'connectorRollOut': [{ type: Output },],
'connectorClick': [{ type: Output },],
'markerRollOver': [{ type: Output },],
'markerRollOut': [{ type: Output },],
'markerClick': [{ type: Output },],
'pageNavigated': [{ type: Output },],
'rotationEnd': [{ type: Output },],
'rotationStart': [{ type: Output },],
'centerLabelRollover': [{ type: Output },],
'centerLabelRollout': [{ type: Output },],
'centerLabelClick': [{ type: Output },],
'centerLabelChanged': [{ type: Output },],
'chartClick': [{ type: Output },],
'chartMouseMove': [{ type: Output },],
'chartRollOver': [{ type: Output },],
'chartRollOut': [{ type: Output },],
'backgroundLoaded': [{ type: Output },],
'backgroundLoadError': [{ type: Output },],
'legendItemClicked': [{ type: Output },],
'legendItemRollover': [{ type: Output },],
'legendItemRollout': [{ type: Output },],
'logoRollover': [{ type: Output },],
'logoRollout': [{ type: Output },],
'logoClick': [{ type: Output },],
'logoLoaded': [{ type: Output },],
'logoLoadError': [{ type: Output },],
'beforeExport': [{ type: Output },],
'exported': [{ type: Output },],
'exportCancelled': [{ type: Output },],
'beforePrint': [{ type: Output },],
'printComplete': [{ type: Output },],
'printCancelled': [{ type: Output },],
'dataLabelClick': [{ type: Output },],
'dataLabelRollOver': [{ type: Output },],
'dataLabelRollOut': [{ type: Output },],
'scrollStart': [{ type: Output },],
'scrollEnd': [{ type: Output },],
'onScroll': [{ type: Output },],
'zoomReset': [{ type: Output },],
'zoomedOut': [{ type: Output },],
'zoomedIn': [{ type: Output },],
'zoomed': [{ type: Output },],
'zoomModeChanged': [{ type: Output },],
'pinned': [{ type: Output },],
'dataRestored': [{ type: Output },],
'beforeDataSubmit': [{ type: Output },],
'dataSubmitError': [{ type: Output },],
'dataSubmitted': [{ type: Output },],
'dataSubmitCancelled': [{ type: Output },],
'chartUpdated': [{ type: Output },],
'nodeAdded': [{ type: Output },],
'nodeUpdated': [{ type: Output },],
'nodeDeleted': [{ type: Output },],
'connectorAdded': [{ type: Output },],
'connectorUpdated': [{ type: Output },],
'connectorDeleted': [{ type: Output },],
'labelAdded': [{ type: Output },],
'labelDeleted': [{ type: Output },],
'selectionRemoved': [{ type: Output },],
'selectionStart': [{ type: Output },],
'selectionEnd': [{ type: Output },],
'labelClick': [{ type: Output },],
'labelRollOver': [{ type: Output },],
'labelRollOut': [{ type: Output },],
'labelDragStart': [{ type: Output },],
'labelDragEnd': [{ type: Output },],
'dataplotDragStart': [{ type: Output },],
'dataplotDragEnd': [{ type: Output },],
'processClick': [{ type: Output },],
'processRollOver': [{ type: Output },],
'processRollOut': [{ type: Output },],
'categoryClick': [{ type: Output },],
'categoryRollOver': [{ type: Output },],
'categoryRollOut': [{ type: Output },],
'milestoneClick': [{ type: Output },],
'milestoneRollOver': [{ type: Output },],
'milestoneRollOut': [{ type: Output },],
'chartTypeChanged': [{ type: Output },],
'overlayButtonClick': [{ type: Output },],
'loaded': [{ type: Output },],
'rendered': [{ type: Output },],
'drawComplete': [{ type: Output },],
'renderComplete': [{ type: Output },],
'dataInvalid': [{ type: Output },],
'dataXMLInvalid': [{ type: Output },],
'dataLoaded': [{ type: Output },],
'noDataToDisplay': [{ type: Output },],
'legendPointerDragStart': [{ type: Output },],
'legendPointerDragStop': [{ type: Output },],
'legendRangeUpdated': [{ type: Output },],
'alertComplete': [{ type: Output },],
'realTimeUpdateError': [{ type: Output },],
'dataplotRollOver': [{ type: Output },],
'dataplotRollOut': [{ type: Output },],
'dataplotClick': [{ type: Output },],
'linkClicked': [{ type: Output },],
'beforeRender': [{ type: Output },],
'renderCancelled': [{ type: Output },],
'beforeResize': [{ type: Output },],
'resized': [{ type: Output },],
'resizeCancelled': [{ type: Output },],
'beforeDispose': [{ type: Output },],
'disposed': [{ type: Output },],
'disposeCancelled': [{ type: Output },],
'linkedChartInvoked': [{ type: Output },],
'beforeDrillDown': [{ type: Output },],
'drillDown': [{ type: Output },],
'beforeDrillUp': [{ type: Output },],
'drillUp': [{ type: Output },],
'drillDownCancelled': [{ type: Output },],
'drillUpCancelled': [{ type: Output },],
'initialized': [{ type: Output },],
};
}
export { FroalaChartsComponent };

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
